import { useEffect, useState } from "react"
import { get_payment_history } from '../../../../server/requests'
import { formatDate } from "../../../Util/format_date";
import CardHistory from "./CardHistory"

export default function History({ currency }) {
    // 0 red 1 green

    const [historyList, setHistoryList] = useState([])

    useEffect(() => {
        get_payment_history({}, data => {
            setHistoryList(data)
        }, err => {
            console.log(err)
        })
    }, [])

    return (
        <div className="main_history_payments">
            <h2 className="title_history">History</h2>
            <div className="list_history">
                <CardHistory
                    index={'#'}
                    currency={''}
                    amount={'Amount'}
                    payment_type={'Payment type'}
                    updatedAt={'Date'}
                    description={'Description'}
                    status={'Status'}
                    class_name={"header_item_history"}
                />
                {historyList.map((item, index) => {
                    return (
                        <CardHistory
                            key={index}
                            index={index + 1}
                            currency={currency}
                            amount={item.amount}
                            payment_type={item.payment_type}
                            updatedAt={formatDate(new Date(item.updatedAt), 'dd/MM/yyyy hh:mm:ss')}
                            description={item.description}
                            status={item.status}
                            class_name={""}
                        />
                    )
                })}
            </div>
        </div>
    )
}